import { Component, computed, effect, inject, linkedSignal, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl, FormsModule } from '@angular/forms';
import { toSignal } from '@angular/core/rxjs-interop';
import { PropertyDexie } from 'src/app/models/property.model';
import { PropertyService } from 'src/app/services/property.service';
import { SelectComponent, SelectModel } from '@aetherion/ui';
@Component({
    selector: 'app-property-select',
    templateUrl: './property-select.component.html',
    styleUrls: ['./property-select.component.css'],
    standalone: true,
    imports: [CommonModule, FormsModule, SelectComponent]
})
export class PropertySelectComponent {
  private propertyService = inject(PropertyService);

   activeProperty = toSignal<PropertyDexie | null>(this.propertyService.activeProperty);
   properties = toSignal<PropertyDexie[]>(this.propertyService.properties);


   selectModel = computed<SelectModel[]>(() => {

    const properties = this.properties();

    if(properties == null)
      return [];


     return properties.map<SelectModel>((property) => ({id: property.propertyID, displayName: property.name}))
   })


  selectedProperty = linkedSignal<string | null>(() => {
    const activeProperty = this.activeProperty();

    if(activeProperty == null)
      return null;

    return activeProperty.propertyID;
  })



  setActiveProperty(value: string | null)
  {
    const properties = this.properties();

    const activeProperty = properties.find(e => e.propertyID == value);

    this.propertyService.activeProperty.next(activeProperty)
  }

  constructor() {

  }
}
